import p from "classnames";
import t from "react";
import { useTranslation as _ } from "react-i18next";
import { useAuth as G } from "../../hooks/useAuth.js";
import v from "./icon.svg.js";
import s from "./userGreetings.module.scss.js";
function A({
  textColor: o,
  texts: r,
  iconImage: a,
  fontSize: l = 11,
  iconSize: c = 22,
  onCustomerClick: n
}) {
  const {
    login: u,
    customer: e
  } = G(), { t: i } = _(), m = i(e ? "userGreetings.defaultAuthenticatedText" : "userGreetings.defaultUnAuthenticatedText"), g = ((e ? r.logged : r == null ? void 0 : r.guest) || m).replace(/\*\|customer_name\|\*/, (e == null ? void 0 : e.profile.firstName) ?? ""), f = () => {
    if (!e) {
      u();
      return;
    }
    n == null || n();
  }, d = n && e || !e;
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      "data-testid": "user-greetings",
      className: p({
        [s.userGreetings]: !0,
        [s.userGreetings__Interactive]: d
      }),
      style: {
        "--textColor": o,
        "--iconSize": `${c}px`,
        "--fontSize": `${l}px`
      },
      onClick: () => f()
    },
    /* @__PURE__ */ t.createElement("div", { className: s.userGreetings__IconWrapper }, a && /* @__PURE__ */ t.createElement("img", { src: a, alt: "user-icon" }), !a && /* @__PURE__ */ t.createElement(v, null)),
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: s.userGreetings__text,
        dangerouslySetInnerHTML: {
          __html: g
        }
      }
    )
  );
}
export {
  A as UserGreetings
};
//# sourceMappingURL=UserGreetings.js.map
